import { styled } from '@clickcease/cc-client-components-lib'
export const InputWithTitleStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '250px',

  variants: {
    size: {
      fullRow: {
        width: 'calc(100% - 12px)',
      },
      small: {
        width: '196px',
      },
    },
  },
})

export const EditableSectionTitle = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '4px',
})
